import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowCircularProgress: Components<Theme>['MuiCircularProgress'] = {
  defaultProps: {
    size: 24,
    thickness: 8,
    enableTrackSlot: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brand.primary,
    }),
    circle: {
      strokeLinecap: 'round',
    },
    track: ({ theme }) => ({
      opacity: '1',
      stroke: theme.palette.mode === 'dark' ? theme.palette.onSurface.os700 : theme.palette.transparent.secondary,
    }),
  },
};
